<template>
    <div>
        <div v-if="!editMode" :style="{ cursor: isAdmin ? 'grab' : 'default' }" class="d-flex justify-content-between align-items-center kanban-non-card">
            <h5 @click="openEdit(status.id)">
<!--                <b-icon v-if="isAdmin" icon="grip-vertical"></b-icon>-->
<!--                <div class="d-inline-block mr-2" :style="{ height: '20px', width: '20px', borderRadius: '50%', backgroundColor: status.color }">&nbsp;</div>-->
                <span :class="{ 'admin_editable': isAdmin }">{{ status.name }}</span>
            </h5>

            <b-dropdown v-if="isAdmin" variant="outline" right size="sm" no-caret class="mb-2" toggle-class="status-menu-button">
                <template v-slot:button-content>
                    <b-icon icon="three-dots" aria-hidden="true"></b-icon>
                </template>
                <b-dropdown-item @click="openEdit(status.id)">Edit</b-dropdown-item>
                <b-dropdown-item @click="showModal">Add status after</b-dropdown-item>
                <b-dropdown-item @click="deleteStatus">Delete</b-dropdown-item>
            </b-dropdown>
        </div>
        <div v-else class="d-flex align-items-center">
            <input
                v-model="editedName"
                @keyup.enter="update"
                type="text"
                class="form-control mr-2"
            />
            <input
                v-model="editedColor"
                @change="update"
                type="color"
                class="form-control"
                style="width: 50px;"
            />
        </div>

        <add-status-modal
            :is-modal-visible="isModalVisible"
            @hide="isModalVisible = false"
            :tab-id="status.tab_id"
            :after-status-id="status.id"
            @status-created="handleStatusCreated"
        />
    </div>
</template>

<script>
import AddStatusModal from './AddStatusModal.vue';

export default {
    components: {
        AddStatusModal
    },
    props: {
        status: {
            type: Object,
            required: true
        },
        isAdmin: {
            type: Boolean,
            required: true
        },
        canDelete: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            editMode: false,
            editedName: '',
            editedColor: '',
            isModalVisible: false
        };
    },
    methods: {
        openEdit(id) {
            if (!this.isAdmin) return;
            this.editMode = true;
            this.editedName = this.status.name;
            this.editedColor = this.status.color;
        },
        showModal() {
            this.isModalVisible = true;
        },
        handleStatusCreated(newStatus) {
            this.$emit('status-created', newStatus, this.status.id);
        },
        update() {
            if (!this.editedName.trim()) {
                alert('The status name must be given.');
                return;
            }
            this.$http.put(`/http_api/statuses/${this.status.id}`, {
                name: this.editedName,
                color: this.editedColor
            })
                .then(response => {
                    this.$emit('update-status', response.data.data);
                    this.editMode = false;
                })
                .catch(error => {
                    console.error(error);
                    alert('Error updating status. Please try again.');
                });
        },
        deleteStatus() {
            if (!this.canDelete) {
                alert('You can only delete statuses without posts.');
                return;
            }

            const confirmDelete = confirm('Are you sure you want to delete this status?');
            if (confirmDelete) {
                this.$http.delete(`/http_api/statuses/${this.status.id}`)
                    .then(() => {
                        this.$emit('delete-status', this.status.id);
                    })
                    .catch(error => {
                        console.error(error);
                        alert('Error deleting status. Please try again.');
                    });
            }
        }
    },
    watch: {
        status: {
            handler(newStatus) {
                this.editedName = newStatus.name;
                this.editedColor = newStatus.color;
            },
            immediate: true
        }
    }
};
</script>